import { DatePicker, Flex, Typography } from 'antd'
import { Dayjs } from 'dayjs'
import { FC } from 'react'
import styled from 'styled-components'
import { PRINTER_SUMMARY_LABELS } from '../constants/printer-summary-labels'
import usePrinterPrintJobs from '../hooks/use-printer-print-jobs'
import PrintJobsTable from './print-jobs-table'
import SummaryStatCard from './summary-stat-card'

const SectionTitle = styled(Typography.Title)`
    margin-top: 0 !important;
    margin-bottom: 16px !important;
`

const StatsColumn = styled(Flex)`
    flex: 0 0 220px;
    min-width: 220px;
`

const TableColumn = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`

const MonthPickerRow = styled(Flex)`
    margin-bottom: 16px;
`

interface PrinterMonthlySummaryProps {
    month: Dayjs
    onMonthChange: (month: Dayjs) => void
}

const PrinterMonthlySummary: FC<PrinterMonthlySummaryProps> = ({ month, onMonthChange }) => {
    const { rows, isLoading, stats } = usePrinterPrintJobs(month)

    return (
        <div>
            <SectionTitle level={4}>Сводка за месяц</SectionTitle>

            <MonthPickerRow align='center' gap={12}>
                <Typography.Text style={{ width: 60 }}>Месяц:</Typography.Text>
                <DatePicker
                    picker='month'
                    value={month}
                    onChange={value => value && onMonthChange(value)}
                    allowClear={false}
                    style={{ width: 140 }}
                />
            </MonthPickerRow>

            <Flex gap={24} align='stretch'>
                <StatsColumn vertical gap={8}>
                    <SummaryStatCard
                        label={PRINTER_SUMMARY_LABELS.time}
                        value={stats.time}
                        tone={stats.timeTone}
                    />
                    <SummaryStatCard label={PRINTER_SUMMARY_LABELS.volume} value={stats.volume} />
                    <SummaryStatCard
                        label={PRINTER_SUMMARY_LABELS.savings}
                        value={stats.savings}
                        tone={stats.savingsTone}
                    />
                    <SummaryStatCard
                        label={PRINTER_SUMMARY_LABELS.overuseDeduction}
                        value={stats.overuseDeduction}
                    />
                    <SummaryStatCard
                        label={PRINTER_SUMMARY_LABELS.bonus}
                        value={stats.bonus}
                        tone={stats.bonusTone}
                    />
                </StatsColumn>

                <TableColumn>
                    <PrintJobsTable rows={rows} isLoading={isLoading} />
                </TableColumn>
            </Flex>
        </div>
    )
}

export default PrinterMonthlySummary
